/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Tuda_Linguistics15Inputs */

const en__field_enum_tuda_linguistics15 = /** @type {(inputs: _Field_Enum_Tuda_Linguistics15Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Linguistics & Cultural Science`)
};

const de__field_enum_tuda_linguistics15 = /** @type {(inputs: _Field_Enum_Tuda_Linguistics15Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Linguistik & Kulturwissenschaften`)
};

/**
* | output |
* | --- |
* | "Linguistics & Cultural Science" |
*
* @param {_Field_Enum_Tuda_Linguistics15Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_tuda_linguistics15 = /** @type {((inputs?: _Field_Enum_Tuda_Linguistics15Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Tuda_Linguistics15Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_tuda_linguistics15(inputs)
	return de__field_enum_tuda_linguistics15(inputs)
});
export { _field_enum_tuda_linguistics15 as "_field_enum_TUDA_LINGUISTICS" }